/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Account_Reviews_Written_OnInputs */

const he_account_reviews_written_on = /** @type {(inputs: Account_Reviews_Written_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`נכתב ב-${i?.date}`)
};

const en_account_reviews_written_on = /** @type {(inputs: Account_Reviews_Written_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Written on ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Written on {date}" |
*
* @param {Account_Reviews_Written_OnInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_reviews_written_on = /** @type {((inputs: Account_Reviews_Written_OnInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Reviews_Written_OnInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_reviews_written_on(inputs)
	return en_account_reviews_written_on(inputs)
});